import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import {
  accessTokenAtom,
  conversationsAtom,
  frameParamsAtom,
  feedbackAtom,
} from 'src/app/state/atoms';
import { IConversationHistoryResponseType, IConversations } from 'src/types/serviceResponseTypes';
import { BFF_ENDPOINTS } from 'src/app/constants';
import networkService from 'src/app/lib/network-service';
import withHistoryMapper from 'src/app/utils/withHistoryMapper';

/**
 * Network hook to fetch conversation history
 */
function useChatAction() {
  const [conversations, setConversations] = useRecoilState(conversationsAtom);
  const [feedbackData] = useRecoilState(feedbackAtom);
  const [accessToken] = useRecoilState(accessTokenAtom);
  const [frameParams] = useRecoilState(frameParamsAtom);

  const fetchConversatoinHistory = useCallback(async () => {
    setConversations({
      ...conversations,
      loading: true,
    });

    const headers = {
      'X-Authorization': 'Bearer ' + accessToken,
    };

    networkService
      .get(
        (process.env.REACT_APP_BASE_URL ?? '') + BFF_ENDPOINTS.CHAT_ACTION + frameParams.book_code + '/exercises/' + frameParams.exercise_id + '/conversations/' + frameParams.conversation_id + '/chat-actions',
        {},
        headers
      )
      .then((response) => {
        if (response.status) {
          setConversations({
            loading: false,
            data: withHistoryMapper(response.data as IConversationHistoryResponseType),
            error: response.error,
          });
        } else {
          setConversations({
            loading: false,
            data: {} as IConversations,
            error: response.error,
          });
        }
      });
  }, [conversations, setConversations, frameParams, accessToken, feedbackData]);

  return fetchConversatoinHistory;
}

export default useChatAction;
